import React from "react";
import Contactus from "../images/Contactus.jpeg";

export default function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-header">
          <h2>Contact Us</h2>
          <p className="section-subtitle">Get in touch for your solar needs</p>
        </div>
        <div className="contact-content">
          <div className="contact-info-box">
            <h3>Let's Start Your Solar Journey</h3>
            <p>Contact us today for a free consultation and quote.</p>
            <div className="contact-methods">
              <div className="contact-item">
                <div className="contact-icon">📱</div>
                <div className="contact-details">
                  <h4>Mobile Number</h4>
                  <a href="tel:+919861006393">+91 9861006393</a>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">💬</div>
                <div className="contact-details">
                  <h4>WhatsApp</h4>
                  <a
                    href="https://wa.me/919040631984"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    +91 9040631984
                  </a>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">✉️</div>
                <div className="contact-details">
                  <h4>Email</h4>
                  <a href="mailto:debasis399@gmail.com">
                    debasis399@gmail.com
                  </a>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div className="contact-details">
                  <h4>Location</h4>
                  <p>Mahimanagar, Nayabazar, Cuttack-753004, Odisha</p>
                </div>
              </div>
            </div>
          </div>
          <div className="contact-image">
            <img
              src= {Contactus}
              alt="Solar System Diagram"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
